export default "__VITE_ASSET__4$F9YuMs__"